import CustomEventDispatcher from './CustomEventDispatcher';

class LoadingService extends CustomEventDispatcher {
  constructor() {
    super();
    this.activeRequests = 0;
    this.isLoading = false;
  }

  startLoading() {
    this.activeRequests++;
    if (!this.isLoading) {
      this.isLoading = true;
      this.dispatchEvent(new CustomEvent('loadingStart'));
    }
  }

  stopLoading() {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    if (this.activeRequests === 0 && this.isLoading) {
      this.isLoading = false;
      this.dispatchEvent(new CustomEvent('loadingStop'));
    }
  }

  forceStop() {
    this.activeRequests = 0;
    this.isLoading = false;
    this.dispatchEvent(new CustomEvent('loadingStop'));
  }

  getIsLoading() {
    return this.isLoading;
  }
}

// Singleton instance
const loadingService = new LoadingService();
export default loadingService;

